<template>
  <b-modal
    v-model="showDetailModal"
    title="Detail Social Learning"
    size="lg"
    hide-footer
    centered
  >
    <div v-if="selectedProject">
      <b-alert
        class="mt-n4 mx-n4"
        show
        style="background-color: #fafafa; border: none"
      >
        <b-row
          class="m-0 p-0 d-flex justify-content-between align-items-center"
        >
          <b-col>
            <h4 class="text-secondary">
              <i class="fe fe-info-circle"></i>
              You can manage this social learning with this action
            </h4>
          </b-col>
          <!-- Action Buttons Section -->
          <b-col class="d-flex justify-content-end gap-2 p-3">
            <b-button variant="info" size="sm" @click="editCoaching">
              <i class="fe fe-edit me-1"></i>
              Edit
            </b-button>
            <b-button variant="danger" size="sm" @click="deleteCoaching">
              <i class="fe fe-trash me-1"></i>
              Delete
            </b-button>
          </b-col>
        </b-row>
      </b-alert>

      <b-row>
        <b-col class="col-6">
          <div>
            <h2 class="fw-bold mb-1">{{ selectedProject.coaching_title }}</h2>
            <b-badge
              class="me-1 mt-3 p-3"
              :style="{
                backgroundColor:
                  selectedProject.type === 'C' ? '#E5FBF2' : '#D7EFF6',
                color: selectedProject.type === 'C' ? '#00AE65' : '#2E8CA7',
                border: 'none',
              }"
            >
              {{ selectedProject.type === "C" ? "COACHING" : "MENTORING" }}
            </b-badge>
          </div>
          <div class="mt-3">
            <i class="fe fe-user me-2"></i>
            <span>{{ selectedProject.coach_name || "-" }}</span>
          </div>
        </b-col>
        <b-col class="col-6">
          <b-img
            :src="
              selectedProject.thumbnail ||
              'https://dummyimage.com/400x200/6c757d/fff&text=Coaching+Thumbnail'
            "
            fluid
            alt="thumbnail"
            class="rounded mb-3"
            style="max-height: 250px; object-fit: cover"
          />
        </b-col>
      </b-row>

      <b-alert
        class="rounded-2 pb-2 mt-4"
        show
        style="background-color: #fafafa; border: none"
      >
        <b-row
          class="m-0 p-0 d-flex justify-content-between align-items-center"
        >
          <b-col class="m-0 p-0">
            <h4 class="text-secondary">
              <p class="fw-light">Methodology:</p>
              <p>
                <i class="fe fe-book"></i>
                {{ selectedProject.methodology || "No Methodology available." }}
              </p>
            </h4>
          </b-col>
        </b-row>
      </b-alert>

      <b-row class="mt-2">
        <b-col>
          <strong>Related Competencies:</strong>
        </b-col>
        <div class="mt-2">
          <b-badge
            v-for="(comp, idx) in selectedProject.related_competencies"
            :key="idx"
            class="me-2 mb-1 p-2 rounded"
            :style="{
              backgroundColor: 'transparent',
              border: `1px solid black`,
              color: 'black ',
            }"
          >
            {{ comp.competency_name }}
          </b-badge>
        </div>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "DetailCoaching",
  props: {
    showDetailModal: {
      type: Boolean,
      required: true,
    },
    selectedProject: {
      type: Object,
      required: false,
      default: null,
    },
  },
  emits: ["close", "edit", "delete"],
  methods: {
    closeModal() {
      this.$emit("close");
    },
    editCoaching() {
      this.$emit("edit", this.selectedProject);
    },
    deleteCoaching() {
      const h = this.$createElement;

      // bikin isi modal-nya (VNode)
      const messageVNode = h("div", null, [
        h("p", { class: "fw-bold mb-2" }, [
          "Apakah Anda yakin ingin menghapus ",
          h(
            "span",
            { class: "text-secondary" },
            `"${this.selectedProject.coaching_title}"`
          ),
          "?",
        ]),
        h(
          "b-alert",
          {
            props: { variant: "warning", show: true },
            style: "border: none; background-color: #fff3cd; color: #856404;",
          },
          [
            h("div", { class: "d-flex align-items-center" }, [
              h("i", {
                class: "fe fe-alert-triangle text-warning me-2",
                style: "font-size: 2rem",
              }),
              h(
                "h5",
                { class: "mb-0" },
                "Pastikan tindakan ini tidak berdampak pada data lain!"
              ),
            ]),
          ]
        ),
      ]);
      // panggil confirm modal-nya
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: "Konfirmasi Hapus",
          size: "sm",
          okVariant: "danger",
          okTitle: "Hapus",
          cancelTitle: "Batal",
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.$emit("delete", this.selectedProject);
          }
        })
        .catch((err) => {
          console.error("Error showing confirm modal:", err);
        });
    },
  },
  watch: {
    showDetailModal(val) {
      if (!val) this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-body {
  font-size: 0.95rem;
}

.gap-2 {
  gap: 0.5rem;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.btn {
  transition: all 0.2s ease-in-out;
}

.btn:hover {
  transform: translateY(-1px);
}
</style>
